import { gql } from "@apollo/client";

export const FETCH_PRODUCT_ANALYTICS = gql`
  query FetchProductAnalytics($filter: ProductAnalyticsFilterInput) {
    me {
      productAnalytics(filter: $filter) {
        summary {
          spend
          rev
          quantity
          total_revenue_first_time
          returning_total_revenue
          proportional_spend
          order_rev
          txns
          product_title_latest
          product_id
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_BY_DATE = gql`
  query FetchProductAnalyticsProductTabByDate(
    $filter: ProductAnalyticsFilterWithProductIdsInput
  ) {
    me {
      productAnalyticsProductTabByDate(filter: $filter) {
        summary {
          localdate {
            value
          }
          spend
          rev
          quantity
          order_rev
          total_revenue_first_time
          returning_total_revenue
          proportional_spend
          txns
          product_title_latest
          product_id
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_BY_AD = gql`
  query FetchProductAnalyticsByAd(
    $filter: ProductAnalyticsFilterWithProductIdsPlatformAndCampaignInput
  ) {
    me {
      productAnalyticsByAd(filter: $filter) {
        summary {
          ad
          ad_name
          campaign
          campaign_name
          order_rev
          preview_gcs_bucket
          preview_gcs_prefix
          preview_url
          proportional_spend
          platform
          quantity
          returning_total_revenue
          rev
          spend
          total_revenue_first_time
          txns
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_PRODUCTS_BY_PLATFORM_CAMPAIGN_AD = gql`
  query FetchProductAnalyticsProductsByPlatformCampaignAd(
    $filter: ProductAnalyticsFilterWithPlatformCampaignAndAdInput
  ) {
    me {
      ProductAnalyticsProductsByPlatformCampaignAd(filter: $filter) {
        summary {
          product_id_source
          product_id
          product_title_latest
          rev
          order_rev
          txns
          quantity
          spend
          proportional_spend
          total_revenue_first_time
          returning_total_revenue
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_PRODUCTS_BY_PLATFORM_AND_CAMPAIGN = gql`
  query FetchProductAnalyticsProductsByPlatformAndCampaign(
    $filter: ProductAnalyticsFilterWithPlatformInputAndCampaign
  ) {
    me {
      productAnalyticsProductsByPlatformAndCampaign(filter: $filter) {
        summary {
          product_id_source
          product_id
          product_title_latest
          rev
          order_rev
          txns
          quantity
          spend
          proportional_spend
          total_revenue_first_time
          returning_total_revenue
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_PRODUCTS_BY_PLATFORM = gql`
  query FetchProductAnalyticsProductsByPlatform(
    $filter: ProductAnalyticsFilterWithPlatformInput
  ) {
    me {
      productAnalyticsProductsByPlatform(filter: $filter) {
        summary {
          spend
          proportional_spend
          rev
          order_rev
          txns
          quantity
          total_revenue_first_time
          returning_total_revenue
          product_title_latest
          product_id_source
          product_id
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_BY_AD_WITH_DATE = gql`
  query FetchProductAnalyticsByAdWithDate(
    $filter: ProductAnalyticsFilterWithProductIdsPlatformAndCampaignInput
  ) {
    me {
      productAnalyticsAdTabByDate(filter: $filter) {
        summary {
          ad
          ad_name
          preview_gcs_bucket
          preview_gcs_prefix
          preview_url
          spend
          rev
          order_rev
          total_revenue_first_time
          returning_total_revenue
          txns
          quantity
          localdate {
            value
          }
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_BY_CAMPAIGN = gql`
  query FetchProductAnalyticsByCampaign(
    $filter: ProductAnalyticsFilterWithProductIdsAndPlatformInput
  ) {
    me {
      productAnalyticsByCampaign(filter: $filter) {
        summary {
          campaign
          name
          campaign_name
          platform
          rev
          order_rev
          txns
          quantity
          spend
          proportional_spend
          total_revenue_first_time
          returning_total_revenue
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_BY_CAMPAIGN_BY_DATE = gql`
  query FetchProductAnalyticsByCampaignByDate(
    $filter: ProductAnalyticsFilterWithProductIdsAndPlatformInput
  ) {
    me {
      productAnalyticsByCampaignByDate(filter: $filter) {
        summary {
          campaign
          name
          campaign_name
          platform
          rev
          order_rev
          txns
          quantity
          spend
          proportional_spend
          total_revenue_first_time
          returning_total_revenue
          localdate {
            value
          }
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_BY_PLATFORM = gql`
  query FetchProductAnalyticsByPlatform(
    $filter: ProductAnalyticsFilterWithProductIdsInput
  ) {
    me {
      productAnalyticsByPlatform(filter: $filter) {
        summary {
          proportional_spend
          rev
          txns
          quantity
          order_rev
          total_revenue_first_time
          returning_total_revenue
          platform_label
          spend
          platforms
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_ANALYTICS_PLATFORM_BY_DATE = gql`
  query FetchProductAnalyticsPlatformTabByDate(
    $filter: ProductAnalyticsFilterWithProductIdsInput
  ) {
    me {
      productAnalyticsPlatformTabByDate(filter: $filter) {
        summary {
          spend
          proportional_spend
          rev
          txns
          quantity
          order_rev
          total_revenue_first_time
          returning_total_revenue
          platform_label
          platforms
          localdate {
            value
          }
        }
      }
    }
  }
`;
export const FETCH_PRODUCT_ANALYTICS_RANKINGS = gql`
  query FetchProductAnalyticsRankings($filter: ProductAnalyticsFilterInput) {
    me {
      productAnalyticRankings(filter: $filter) {
        summary {
          collection_id
          localdate {
            value
          }
          collection_name
          spend
          rev
          cust_stage_first_time_rev
          cust_stage_returning_rev
          txns
          quantity
          product_ids_and_names {
            product_id
            product_title_latest
          }
        }
      }
    }
  }
`;
